import { useSearchParams } from "react-router-dom";
import { PageHeader, Tabs } from "../components/ui";
import { WypisySection } from "./WypisyPage";
import { MzSection } from "./MzPage";
import { MpzpSection } from "./MpzpPage";
import { MdcpOrdersSection } from "./MdcpOrdersSection";

export type MaterialsTab = "wypisy" | "mz" | "mpzp" | "mdcp";
const MATERIALS_TABS: MaterialsTab[] = ["wypisy", "mz", "mpzp", "mdcp"];

/* „Zamawianie materiałów" — cztery rejestry zamówień u urzędów/geodetów (dawniej
   cztery pozycje lewego menu) w jednej stronie z zakładkami. Zakładka żyje w URL
   (?tab=mz), żeby linki z zakładek projektu i powiadomień prowadziły prosto do
   właściwej sekcji; stare adresy /wypisy, /mz, /mpzp przekierowują tutaj z
   zachowaniem parametrów (np. ?connection= zawężające MPZP do projektu). */
export function MaterialsOrderingPage() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab");
  const tab: MaterialsTab = MATERIALS_TABS.includes(raw as MaterialsTab)
    ? (raw as MaterialsTab)
    : "wypisy";
  // Zmiana zakładki zrzuca filtry poprzedniej (np. ?connection= należy do MPZP).
  const setTab = (k: MaterialsTab) =>
    setParams(k === "wypisy" ? {} : { tab: k }, { replace: true });

  return (
    <div className="space-y-4">
      <PageHeader
        title="Zamawianie materiałów"
        subtitle="Wypisy EGiB, mapy zasadnicze, wypisy MPZP i mapy do celów projektowych — zamówienia ze wszystkich projektów ZE · DLC_01"
      />

      <Tabs
        tabs={[
          { key: "wypisy" as const, label: "Wypisy" },
          { key: "mz" as const, label: "Mapy MZ" },
          { key: "mpzp" as const, label: "MPZP" },
          { key: "mdcp" as const, label: "MDCP" },
        ]}
        active={tab}
        onChange={setTab}
      />

      {tab === "wypisy" && <WypisySection />}
      {tab === "mz" && <MzSection />}
      {tab === "mpzp" && <MpzpSection />}
      {tab === "mdcp" && <MdcpOrdersSection />}
    </div>
  );
}
